import { render, staticRenderFns } from "./KameDocuments.vue?vue&type=template&id=aa171a80&scoped=true&"
import script from "./KameDocuments.vue?vue&type=script&lang=js&"
export * from "./KameDocuments.vue?vue&type=script&lang=js&"
import style0 from "./KameDocuments.vue?vue&type=style&index=0&id=aa171a80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa171a80",
  null
  
)

export default component.exports